<div class="db-add-domain-list-dialog">
  <div class="db-nameServers-block">
    <h3 class="mb8">{{ 'text_domainAddedToYourSiteHeader' | dbText }}</h3>
    <p class="mb30">{{ 'text_customDomainAddDNSRecordsDesc' | dbText }}</p>

    <div class="db-copy-info mt15">
      <div class="db-copy-info__list-header">
          <p>{{ 'text_type' | dbText }}</p>
          <p>{{ 'text_name' | dbText }}</p>
          <p>{{ 'text_value' | dbText }}</p>
      </div>
      <ul>
        <li class="db-copy-info__list-item">
          <p>A</p>
          <div>
            <input type="text" class="form-control host-name" [value]="domain" #inputHostName readonly>
            <a [ngxClipboard]="inputHostName" (cbOnSuccess)="copied(inputHostName?.value)" (click)="isCopied = true"
               (onTooltipHide)="isCopied = false"
               class="db-icon db-icon-ds-copy" dsTooltipSize="small" dsTooltipPosition="top"
               [hostClass]="'cover-all'"
               dsTooltipColor="white"
               [dsTooltip]="'<b>' + ((isCopied ? 'text_copied' : 'text_copy') | dbText) +'</b>'">
            </a>
          </div>

          <div>
            <input type="text" class="form-control" [value]="ipv4Address" #inputNameServerA readonly>
            <a [ngxClipboard]="inputNameServerA" (cbOnSuccess)="copied(inputNameServerA?.value)" (click)="isCopied = true"
               (onTooltipHide)="isCopied = false"
               class="db-icon db-icon-ds-copy" dsTooltipSize="small" dsTooltipPosition="top"
               [hostClass]="'cover-all'"
               dsTooltipColor="white"
               [dsTooltip]="'<b>' + ((isCopied ? 'text_copied' : 'text_copy') | dbText) +'</b>'">
            </a>
          </div>

        </li>
        <li class="db-copy-info__list-item">
          <p>CNAME</p>

          <div>
            <input type="text" class="form-control host-name" [value]="'www.' + domain" #inputHostNameCNAME>
            <a [ngxClipboard]="inputHostNameCNAME" (cbOnSuccess)="copied(inputHostNameCNAME?.value)" (click)="isCopied = true"
               (onTooltipHide)="isCopied = false"
               class="db-icon db-icon-ds-copy" dsTooltipSize="small" dsTooltipPosition="top"
               [hostClass]="'cover-all'"
               dsTooltipColor="white"
               [dsTooltip]="'<b>' + ((isCopied ? 'text_copied' : 'text_copy') | dbText) +'</b>'">
            </a>
          </div>

          <div>
            <input type="text" class="form-control" [value]="domain" #inputNameServerCNAME readonly>
            <a [ngxClipboard]="inputNameServerCNAME" (cbOnSuccess)="copied(inputNameServerCNAME?.value)" (click)="isCopied = true"
               (onTooltipHide)="isCopied = false"
               class="db-icon db-icon-ds-copy" dsTooltipSize="small" dsTooltipPosition="top"
               [hostClass]="'cover-all'"
               dsTooltipColor="white"
               [dsTooltip]="'<b>' + ((isCopied ? 'text_copied' : 'text_copy') | dbText) +'</b>'">
            </a>
          </div>

        </li>
      </ul>
    </div>
  </div>

  <div class="db-dns-block">
    <div class="db-dns-zone-text mb20">
      <p>
        {{(zoneNotCreated ? 'text_zoneCreateProblemTitle': 'text_zoneLimitExceededTitle') | dbText }}
      </p>
      <span *ngIf="!zoneNotCreated">{{'text_youHaveExceededYourDNSZoneLimit' | dbText}}</span>
      <span *ngIf="zoneNotCreated">{{'text_itIsPossibleThatDNSZoneAlreadyExists' | dbText}}</span>
    </div>
    <div class="db-add-domain-list-dialog__footer mt30">
      <button class="ds-btn-black" (click)="activeModal.close({success: true})">
        <span>{{ 'text_gotIt' | dbText }}</span>
      </button>
    </div>
  </div>
</div>
